export const STAFF_ROLES = 'STAFF_ROLES';
export const BUILDING_FIELD = 'BUILDING_FIELD';
export const MASTER_PM_FIELD = 'MASTER_PM_FIELD';
export const DOORS_AND_CAMERAS = 'DOORS_AND_CAMERAS';
export const AMENITY_NOTES = 'AMENITY_NOTES';
export const AMENITY_ACTIVE = 'AMENITY_ACTIVE';
export const FREEZED_BUILDING = 'FREEZED_BUILDING';
export const LINK_DISPLAY_NAME = 'LINK_DISPLAY_NAME';

export const INFO_TYPES = {
  STAFF_ROLES: {
    url: 'https://carsonhelp.zendesk.com/hc/en-us/articles/360004979951-Staff-User-Access-Levels',
    title: 'Click to get more info',
  },
  BUILDING_FIELD: {
    url: null,
    title:
      'If left blank then staff will automatically be assigned to all buildings across the Property Management Company',
  },
  MASTER_PM_FIELD: {
    url: null,
    title:
      'The staff will automatically be assigned to all buildings in the PMC',
  },
  DOORS_AND_CAMERAS: {
    url: null,
    title: 'Select a building to see additional doors',
  },
  AMENITY_NOTES: {
    url: null,
    title: 'Visible to all Staff, Owners & Residents',
  },
  AMENITY_ACTIVE: {
    url: null,
    title: 'Only active amenities are available for reservations',
  },
  FREEZED_BUILDING: {
    url: null,
    title:
      'Frozen buildings will not appear in the buildings lists in the Web app and will be disabled in the mobile apps',
  },
  LINK_DISPLAY_NAME: {
    url: null,
    title: 'This is the name that will be shown to users in the app',
  },
};
